import React, { useEffect, useState } from 'react'
import { Box, Typography, Avatar, ToggleButton, ToggleButtonGroup, Button, Drawer, Divider, useMediaQuery, IconButton, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
import { Images } from '../../global/GloblImages'
import notification from '../../assets/common/images/notification.png'
import { MenuOutlined, Scale, SmartToyOutlined } from '@mui/icons-material';
import { ApiGetClientEntityId } from '../../apiService/Core/Apicall';
import Domains from '../../global/constants/domain';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/Reducer';
import { setLou } from '../../global/config/Reducer/LouSlice';
import storage from '../../utils/storage';
import path from 'path';
// import logo from "../../assets/Project_Images/App_logo.png"

const drawerWidth = 230;

const SettingIcon: React.FC = () => {
    return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#161B1E" strokeOpacity="0.5" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 12.8801V11.1201C2 10.0801 2.85 9.22006 3.9 9.22006C5.71 9.22006 6.45 7.94006 5.54 6.37006C5.02 5.47006 5.33 4.30006 6.24 3.78006L7.97 2.79006C8.76 2.32006 9.78 2.60006 10.25 3.39006L10.36 3.58006C11.26 5.15006 12.74 5.15006 13.65 3.58006L13.76 3.39006C14.23 2.60006 15.25 2.32006 16.04 2.79006L17.77 3.78006C18.68 4.30006 18.99 5.47006 18.47 6.37006C17.56 7.94006 18.3 9.22006 20.11 9.22006C21.15 9.22006 22.01 10.0701 22.01 11.1201V12.8801C22.01 13.9201 21.16 14.7801 20.11 14.7801C18.3 14.7801 17.56 16.0601 18.47 17.6301C18.99 18.5401 18.68 19.7001 17.77 20.2201L16.04 21.2101C15.25 21.6801 14.23 21.4001 13.76 20.6101L13.65 20.4201C12.75 18.8501 11.27 18.8501 10.36 20.4201L10.25 20.6101C9.78 21.4001 8.76 21.6801 7.97 21.2101L6.24 20.2201C5.33 19.7001 5.02 18.5301 5.54 17.6301C6.45 16.0601 5.71 14.7801 3.9 14.7801C2.85 14.7801 2 13.9201 2 12.8801Z" stroke="#161B1E" strokeOpacity="0.5" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>;
}

function Menue() {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    const navigate = useNavigate()
    const location = useLocation();
    const { mmLogo, Dashboard_Icon, Report_Icon, FixIt_Icon, Category_Icon, ScoreCard_Icon, Checklist, Bsc_Icon, Trend_Icon, StarRating, managearea, managevenue, Comparision_Icon } = Images()
    const isLargeScreen = useMediaQuery('(min-width: 768px)');
    const domain = window.location.hostname;
    const [pathname, setpathname] = useState(location.pathname.split("/")[2])
    const [alignment, setAlignment] = React.useState<string>(pathname);
    const isratingJson = storage.getItem('ratingJson')
    const isCxkpi = process.env.REACT_APP_ISCXKPI || false
    const { isChatOpen } = useSelector((state: RootState) => state.lou)
    const dispatch = useDispatch()
    useEffect(() => {
        setpathname(location.pathname.split("/")[2])
    }, [location.pathname])

    useEffect(()=>{
        setAlignment(pathname)
    },[pathname])

    const handleChange = (_event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (!newAlignment) return;
        setAlignment(newAlignment);
        storage.setItem("ActiveTask", newAlignment)
        localStorage.setItem("ActiveTask", newAlignment)
        handleDrawerClose()
    };

    useEffect(() => {
        if (!location.pathname.startsWith(`/maindashboard/${alignment}`)) {
            navigate(`/maindashboard/${alignment}`)
        }

    }, [alignment])


    const drawer = (
        <Box className='h-100 bg-white' width='fit-content' overflow='auto'>
            <Box sx={{ paddingBottom: { xs: '14px', md: '0px' }, paddingTop: { xs: '10px', md: '4px' }, borderBottom: '1px solid #0000001A', borderRadius: '0px' }} className='w-100 d-flex align-items-center justify-content-center' ml={{ xs: 3, md: 0 }}>
                <Box component='img' src={mmLogo} alt='Company Logo' height={{ xs: '50px', md: '60px' }} sx={{ transform: "Scale(0.8)" }} width='auto' />
            </Box>
            <Box className='d-flex w-100 flex-column align-items-start ps-2 px-lg-2  pt-2' height='calc(100vh - 64px - 100px)'>
                <Typography variant='caption' className='mb-2 ps-3 text-main'>Management Options</Typography>
                <ToggleButtonGroup
                    value={alignment}
                    onChange={handleChange}
                    exclusive
                    className="flex-column gap-1 selected"
                >
                    <ToggleButton value='dashboard' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-3 transform">
                        <Box component='img' src={Dashboard_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box> Dashboard
                    </ToggleButton>

                    <ToggleButton value='reports' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                        <Box component='img' src={Report_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box> Insights
                    </ToggleButton>
                    {domain.includes(Domains.ALDI) &&
                        storage.getItem('clientEntityName') !== 'Liquor ID' && (
                            <>
                                <ToggleButton
                                    value="trendData"
                                    className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform"
                                >
                                    <Box
                                        component="img"
                                        src={Trend_Icon}
                                        className="w-25 m-0 p-0 bg-light p-1"
                                        borderRadius="5px"
                                    />
                                    Trend Data
                                </ToggleButton>

                                {storage.getItem('userRole') === 'clientadmin' && (
                                    <ToggleButton
                                        value="bscData"
                                        className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform"
                                    >
                                        <Box
                                            component="img"
                                            src={Bsc_Icon}
                                            className="w-25 m-0 p-0 bg-light p-1"
                                            borderRadius="5px"
                                        />
                                        BSC Data
                                    </ToggleButton>
                                )}
                            </>
                        )}

                    <ToggleButton value='scoreCard' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                        <Box component='img' src={ScoreCard_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box> Results
                    </ToggleButton>
                   {storage.getItem('ClientGroupName') == "JBHIFI" && ( <ToggleButton
                        value="dataExplorer"
                        className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform"
                    >
                        <Box
                            component="img"
                            src={Trend_Icon}
                            className="w-25 m-0 p-0 bg-light p-1"
                            borderRadius="5px"
                        />
                        Data Explorer
                    </ToggleButton>
                    )}
                    {storage.getItem('clientEntityName') !== 'Liquor ID' && !storage.getItem('INF') && (
                        <ToggleButton value='fixIt' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                            <Box component='img' src={FixIt_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Fix It
                        </ToggleButton>)}

                    {!domain.includes(Domains.ALDI) && isratingJson && isratingJson?.length > 0 && <ToggleButton value='starRating' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                        <Box component='img' src={StarRating} sx={{ transform: 'Scale(1)' }} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Star Rating
                    </ToggleButton>}

                    <ToggleButton value='comparisionReports' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-3 transform">
                        <Box component='img' src={Comparision_Icon} sx={{ transform: 'Scale(0.9)' }} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Comparisions
                    </ToggleButton>
                    {/* {!domain.includes(Domains.ALDI) &&  <ToggleButton value='categoryReport' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-3 transform">
                        <Box component='img' src={Category_Icon} sx={{ transform: 'Scale(0.9)' }} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Category 
                    </ToggleButton>} */}

                    {/* {(storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'venueadmin') && storage.getItem('clientEntityName') !== 'Liquor ID' && <ToggleButton value='checklist' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                        <Box component='img' src={Checklist} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Check List
                    </ToggleButton>} */}
                    {/* {storage.getItem('clientEntityName') !== 'Liquor ID' && <ToggleButton value='checklist' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                        <Box component='img' src={Checklist} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Check List
                    </ToggleButton>} */}
                    {storage.getItem('clientEntityName') !== 'Liquor ID' && <ToggleButton value='Checklist' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                        <Box component='img' src={Checklist} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Checklist
                    </ToggleButton>}

                    {(storage.getItem('userRole') == 'clientadmin' && storage.getItem('clientEntityName') !== 'Liquor ID' && storage.getItem('clientGroupName') !== 'TRANSPORT') && (
                        [
                            <ToggleButton value='manageSites' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-0 transform">
                                <Box component='img' src={managevenue} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Sites
                            </ToggleButton>,
                            <ToggleButton value='manageAreaManagers' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-0 transform">
                                <Box component='img' src={managearea} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box>Area Managers
                            </ToggleButton>
                        ]
                    )}

                    {/* {storage.getItem('ClientGroupName') && storage.getItem('userRole') === 'clientadmin' && storage.getItem('ClientGroupName') !== 'TRANSPORT' && (
                        <ToggleButton value='feedbackQuestions' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                            <Box component='img' src={ScoreCard_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box> Feedback
                        </ToggleButton>
                    )} */}
                    {storage.getItem('ClientGroupName') && (storage.getItem('userRole') === 'clientadmin' || storage.getItem('userRole') === 'areaManager') && storage.getItem('ClientGroupName') !== 'TRANSPORT' && (
                        <ToggleButton value='feedbackQuestions' className="d-flex align-items-center gap-3 fs-14 justify-content-start me-4 transform">
                            <Box component='img' src={ScoreCard_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box> Feedback
                        </ToggleButton>
                    )}


                </ToggleButtonGroup>
                {isCxkpi && storage.getItem('userRole') === 'clientadmin' && (
                    <Box sx={{ cursor: 'pointer' }} onClick={() => { dispatch(setLou(true)) }} bgcolor={isChatOpen == true ? 'var(--primary-color)' : "white"} color={isChatOpen == true ? 'white' : "#0000007A"} className="d-flex p-2 border-10 pe-4 align-items-center mt-3 ms-2 gap-3 fs-14 justify-content-start me-4 transform">
                        {/* <Box component='img' src={ScoreCard_Icon} className='w-25 m-0 p-0 bg-light p-1' borderRadius='5px'></Box> */}
                        <SmartToyOutlined className='bg-light border-10 p-1' sx={{ fontSize: "40px", color: `${isChatOpen == true ? "var(--secondary-color)" : 'var(--primary-color)'}` }} />
                        Ask Lou - BETA
                    </Box>
                )}
                <Divider className='w-75 mx-auto my-4' sx={{ borderColor: "#0000008a" }}></Divider>

                {/* <Box className='ps-1'>
                    <Typography variant='caption' className='mb-2 ps-3 text-main'>Configurations</Typography>
                    <Button
                        className="d-flex mb-2 align-items-center gap-3 fs-14 justify-content-center w-75 mt-auto text-secondary">
                        <SettingIcon></SettingIcon>
                        Setting
                    </Button>
                    <Button
                        className="d-flex mb-1 align-items-center gap-3 ml-3 fs-14 justify-content-center  w-75 mt-auto text-secondary">
                        <Box component='img' src={notification} height='24px' width='24px'></Box>
                        Notification
                    </Button>
                </Box> */}
            </Box>
        </Box>

    );
    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    useEffect(() => {
        const validRoutes = ["MyTask", "ApplyTask", "Calendar", "ReCheck", "MyProfile", "Invoices", "Scorecards"];
        const path = location.pathname.split("/").pop(); // Extract last part of the URL
        if (path && validRoutes.includes(path) && path !== alignment) {
            setAlignment(path);
            if (path) { storage.setItem("ActiveTask", path); localStorage.setItem("ActiveTask", path) }
        }
    }, [location]);
    return (
        <>
            <Box className='bg-white' display={{ xs: 'block', md: 'none' }} height='64px' width='45px' zIndex={1300} position='fixed'>
                {!isLargeScreen && (
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        className='bg-white'
                        onClick={handleDrawerToggle}
                        sx={{ ml: '3px', mt: '3px', position: 'fixed', height: '64px', zIndex: 1300 }}
                    >
                        <MenuOutlined />
                    </IconButton>
                )
                }
            </Box>
            <Box
                component="nav"
                className='bg-white'
                sx={{ width: { lg: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"

            >

                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', lg: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 'fit-content', maxWidth: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"

                    sx={{
                        display: { xs: 'none', lg: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
        </>

    )
}

export default Menue
